export function validateMealPlan(weeklyData, selectedMonth, isNormalSchool) {
    const invalidDates = {};
    let monthIsValid = true;
    const addInvalidDate = (week, day, reason) => {
        invalidDates[`${week}-${day}`] = reason;
    };
    weeklyData.forEach((week) => {
        const weekStats = {
            meat: 0,
            fish: 0,
        };
        Object.values(week.days).forEach((day) => {
            if ("month" in day && day.month !== selectedMonth.getMonth())
                return;
            if ("menus" in day && day.menus.length > 0) {
                const selectedMenuCount = day.menus.filter((menu) => menu.isSelected).length;
                const selectedMenuVegetarianCount = day.menus.filter((menu) => menu.isSelected && menu.label === "vegetarian").length;
                const dayMenuNonVegetarianCount = day.menus.filter((menu) => menu.label !== "vegetarian").length;
                if (isNormalSchool) {
                    if (selectedMenuCount < 2 && selectedMenuVegetarianCount === 0) {
                        addInvalidDate(week.weekNumber, day.dayNumber, dayMenuNonVegetarianCount === 0
                            ? "selectExactlyTwo"
                            : "selectExactlyTwoMinOneVegetarian");
                        monthIsValid = false;
                    }
                    else if (selectedMenuCount === 2 &&
                        selectedMenuVegetarianCount === 0) {
                        addInvalidDate(week.weekNumber, day.dayNumber, "minOneVegetarianPerDay");
                        monthIsValid = false;
                    }
                    else if (selectedMenuCount < 2) {
                        addInvalidDate(week.weekNumber, day.dayNumber, "selectExactlyTwo");
                        monthIsValid = false;
                    }
                    else if (selectedMenuCount > 2) {
                        addInvalidDate(week.weekNumber, day.dayNumber, dayMenuNonVegetarianCount === 0
                            ? "selectMaxTwo"
                            : "selectMaxTwoMinOneVegetarian");
                        monthIsValid = false;
                    }
                }
                else {
                    if (dayMenuNonVegetarianCount > 0 && selectedMenuCount > 2) {
                        monthIsValid = false;
                        addInvalidDate(week.weekNumber, day.dayNumber, "selectMaxTwoMinOneVegetarian");
                    }
                    else if (dayMenuNonVegetarianCount > 0 &&
                        selectedMenuVegetarianCount === 0) {
                        monthIsValid = false;
                        addInvalidDate(week.weekNumber, day.dayNumber, "minOneVegetarianPerDay");
                    }
                    else if (dayMenuNonVegetarianCount === 0 &&
                        selectedMenuCount !== 1) {
                        monthIsValid = false;
                        addInvalidDate(week.weekNumber, day.dayNumber, "selectExactlyOne");
                    }
                }
                if (day.menus.some((menu) => menu.isSelected && menu.label === "fish")) {
                    weekStats.fish++;
                }
                if (day.menus.some((menu) => menu.isSelected && menu.label === "meat")) {
                    weekStats.meat++;
                }
            }
        });
        if (weekStats.fish < 1) {
            Object.values(week.days)
                .filter((day) => "month" in day && day.month === selectedMonth.getMonth())
                .forEach((day) => {
                if ("menus" in day &&
                    day.menus.length > 0 &&
                    day.menus.some((menu) => menu.label === "fish")) {
                    monthIsValid = false;
                    addInvalidDate(week.weekNumber, day.dayNumber, "minOneFishPerWeek");
                }
            });
        }
        if (weekStats.meat > 1) {
            Object.values(week.days)
                .filter((day) => "month" in day && day.month === selectedMonth.getMonth())
                .forEach((day) => {
                if ("menus" in day &&
                    day.menus.length > 0 &&
                    day.menus.some((menu) => menu.label === "meat")) {
                    monthIsValid = false;
                    addInvalidDate(week.weekNumber, day.dayNumber, "maxOneMeatPerWeek");
                }
            });
        }
    });
    return { monthIsValid, invalidDates };
}
//# sourceMappingURL=validateMealPlan.js.map